import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { HomeService } from '../../services/home.service';
import { ModalFormService } from '../../../../shared/components/modal-form/service/modal-form.service';
import { ModalFormHomeService } from '../modal-form-home/service/modal-form-home.service';
import { LoadSpinnerComponent } from '../../../../shared/components/load-spinner/load-spinner.component';
import { DataErrorComponent } from '../../../../shared/components/data-error/data-error.component';
import { InputFieldMaterialComponent } from '../../../../shared/components/input-field-material/input-field-material.component';
import { TextAreaMaterialComponent } from '../../../../shared/components/text-area-material/text-area-material.component';
import { ChipComponent } from '../../../../shared/components/chip/chip.component';

import { TituloComponent } from '../../../../shared/components/titulo/titulo.component';
@Component({
  selector: 'app-form-mensaje-soporte',
  templateUrl: './form-mensaje-soporte.component.html',
  styleUrl: './form-mensaje-soporte.component.scss',
  imports: [
    LoadSpinnerComponent,
    DataErrorComponent,
    InputFieldMaterialComponent,
    ReactiveFormsModule,
    TextAreaMaterialComponent,
    TituloComponent,
  ],
})
export class FormMensajeSoporteComponent implements OnInit, OnDestroy {
  loadEntrada: boolean = false;
  loadSalida: boolean = false;
  disabledForm$: Subscription;

  serviceForm;
  ready_page: number; //0;
  @Input() public soporteForm: FormGroup;
  asunto = new FormControl('', [
    Validators.required,
    Validators.maxLength(100),
  ]);
  mail = new FormControl('', [
    Validators.required,
    Validators.maxLength(100),
    this.customEmailValidator,
  ]);
  nombre = new FormControl('', [
    Validators.required,
    Validators.maxLength(100),
  ]);
  descripcion = new FormControl('', [
    Validators.required,
    Validators.maxLength(1000),
  ]);

  disabledByModify: boolean = false;
  disabledByShow: boolean = false;

  inputs: any;

  dataError: boolean = false;
  pantallaEnviar: boolean = true;
  link: boolean;
  issuekey: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private homeService: HomeService,
    private modalFormService: ModalFormService,
    private modalFormHomeService: ModalFormHomeService
  ) {}

  ngOnInit() {
    this.ready_page = 0;
    this.dataError = false;
    this.soporteForm = this.formBuilder.group({
      asunto: [
        { value: '', disabled: false },
        [Validators.required, Validators.maxLength(100)],
      ],
      mail: [
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.maxLength(100),
          this.customEmailValidator,
        ],
      ],
      nombre: [
        { value: '', disabled: false },
        [Validators.required, Validators.maxLength(100)],
      ],
      descripcion: [
        { value: '', disabled: false },
        [Validators.required, Validators.maxLength(1000)],
      ],
    });

    this.soporteForm.get('asunto').valueChanges.subscribe(value => {
      this.onSubmit();
    });
    this.soporteForm.get('mail').valueChanges.subscribe(value => {
      this.onSubmit();
    });
    this.soporteForm.get('nombre').valueChanges.subscribe(value => {
      this.onSubmit();
    });
    this.soporteForm.get('descripcion').valueChanges.subscribe(value => {
      this.onSubmit();
    });

    this.modalFormService.closeDrawer.subscribe((value: any) => {
      this.clearForm();
    });

    this.modalFormHomeService.modalMode.subscribe((value: boolean) => {
      this.toggleFields(value);
    });
    this.modalFormHomeService.issuekey.subscribe((value: boolean) => {
      this.issuekey = value;
    });
    this.modalFormHomeService.link.subscribe((value: boolean) => {
      this.link = value;
    });

    this.applySupportPrefill();
    this.ready_page = 2;
  }

  // toggleFields(value) {
  //   if (value == 'crear') {
  //     this.disabledByModify = false;
  //     this.disabledByShow = false;
  //   }
  // }
  public onSubmit() {
    // Marcar todos los campos como 'touched'
    Object.keys(this.soporteForm.controls).forEach(key => {
      this.soporteForm.get(key).markAsTouched();
    });
    console.log(this.soporteForm);
    // Forzar la validación después de marcar como 'touched'
    this.soporteForm.updateValueAndValidity();
    if (this.soporteForm.valid) {
      console.log(this.soporteForm.value);
      if (
        this.soporteForm.value.asunto &&
        this.soporteForm.value.mail &&
        this.soporteForm.value.descripcion &&
        this.soporteForm.value.nombre
      ) {
        this.modalFormHomeService.formValue.next(this.soporteForm.value);
      }
    } else {
      //console.error('Formulario inválido');
      this.modalFormHomeService.formValue.next(false);
    }
  }

  ngOnDestroy(): void {}
  // metodo para settear el valor de los formcontrol desde estacionService.formValue
  setFormValue() {
    const form = this.serviceForm;
    this.asunto.setValue(form.model);
    //this.uu_id.setValue(form.uu_id);
  }
  onInputAsunto(value: any[]) {
    // Actualizar asunto
    this.soporteForm.get('asunto').setValue(value);
  }
  onInputMail(value: any[]) {
    // Actualizar mail
    this.soporteForm.get('mail').setValue(value);
  }
  onInputNombre(value: any[]) {
    // Actualizar nombre
    this.soporteForm.get('nombre').setValue(value);
  }
  onInputDescripcion(value: any[]) {
    // Actualizar descripción
    this.soporteForm.get('descripcion').setValue(value);
  }

  toggleFields(value) {
    if (value == 'enviar') {
      this.pantallaEnviar = true;
      this.clearForm();
    } else if (value == 'recibir') {
      this.pantallaEnviar = false;
    }
  }

  clearForm() {
    this.asunto.reset();
    this.mail.reset();
    this.nombre.reset();
    this.descripcion.reset();
    this.soporteForm.reset();
  }

  private applySupportPrefill(): void {
    const prefill = this.modalFormHomeService.takeSupportPrefill();
    if (!prefill) {
      return;
    }

    this.asunto.setValue(prefill.asunto);
    this.mail.setValue(prefill.mail);
    this.nombre.setValue(prefill.nombre);
    this.descripcion.setValue(prefill.descripcion);
    this.soporteForm.patchValue(prefill);
    this.onSubmit();
  }

  customEmailValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email && !emailPattern.test(email)) {
      return { invalidEmail: true };
    }
    return null;
  }
}
